import { CatalogSortOption } from "../settings.model";
import { ProductFilterOption } from "./product-filter.model";


export class PageState {
  constructor(
    public pageNumber: number,
    public position: number,
    public scrollY: number,
    public sort: CatalogSortOption,
    public selectedFilters: ProductFilterOption[]) { }
}
